// import screen_mix from '@/mixins/screen_mix'
// mixins:[screen_mix],

import { checkMaxWindowWidth } from '@/composables/screenMix'

const screen_mix = {
  computed: {
    globals_window_size() {
      return this.$store.getters.globals_window_size
    },
    // 1023
    mobile() {
      return this.$store.getters.globals_mobile
    },
    max1280() {
      return checkMaxWindowWidth(1280, this.globals_window_size.width)
    },
    max768() {
      return checkMaxWindowWidth(768, this.globals_window_size.width)
    },
    max620() {
      return checkMaxWindowWidth(620, this.globals_window_size.width)
    },
    max540() {
      return checkMaxWindowWidth(540, this.globals_window_size.width)
    },
    // globals_fullscreen() {
    //   const { globals_fullscreen } = this.$store.getters; return globals_fullscreen
    // },
  },
}

export default screen_mix
